export const filterKeys = [
  "hotel_name",
  "airline",
  "stars",
  "time_from_src",
  "time_to_src",
  "time_to_dest",
  "time_from_dest",
  "price_to",
  "price_from",
  "hotelName",
  "preferredReachTimes",
  "preferredReturnTimes",
  "isReturnTimeSwitchActive",
  "isReachTimeSwitchActive",
  "filter_by_room",
  "months",
  "transportations",
  "accommodations",
  "boards",
  "beds",
  "transportType"
];
